<template>

	<Verification v-if="!isVerified" @verified="onVerified"></Verification>

	<NavBar v-if="isVerified"></NavBar>

	<div v-if="isVerified" class="body">
		<router-view></router-view>
	</div>

	<Footer v-if="isVerified"></Footer>

</template>

<script lang="ts">
import { defineComponent } from "vue";

import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
import Verification from "./components/Verification.vue";

export default defineComponent({
	name: "App",

	components: {
		NavBar,
		Footer,
		Verification 
	},

	data()
	{
		return {
			isVerified: false
		}
	},

	mounted()
	{
		this.isVerified = this.getCookie("verified") == '1';	
	},

	methods: {
		onVerified()
		{
			this.isVerified = true;
			this.setCookie("verified", "1", 14);
		},
		setCookie(name: string, value: string, days: number) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

			document.cookie =
				`${name}=${value}; expires=${date.toUTCString()}; path=/`;
		},
		getCookie(name: string): string | null {
			const cookies = document.cookie.split("; ");

			for (const c of cookies) {

				const [key, val] = c.split("=");

				if (key === name) {
					return val;
				}
			}

			return null;
		}
	}
});
</script>